import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Actions from "../Redux/action";
import { toast } from "react-toastify";
import moment from "moment";
import ExcelJS from 'exceljs';
import * as FileSaver from 'file-saver';
import nodatafound from '../asset/img/datanotfound_black.png';
import AppDatePicker from "../component/AppDatePicker";
import TimePicker from "rc-time-picker";
import 'rc-time-picker/assets/index.css';
import AppLoader from "../component/AppLoader";
import { getHostelListSelectSelector } from "../Redux/reducer/HostelReducer";
import { ViewQrImagePopup } from "../component/ViewQrImage";
import { PaginationComponent } from "../component/PaginationComponent";
export const QrAccessList = () => {
    const EXCEL_EXTENSION = '.xlsx'
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const dispatch = useDispatch();
    const hostelList = useSelector(getHostelListSelectSelector)
    const defaultTimeState = {
        start_time: moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
        end_time: moment()
    };
    const [formDetails, setFormDetails] = useState({ ...defaultTimeState })
    const [err, setErr] = useState({})
    const [viewReports, setViewReport] = useState(false)
    const [isLoading, setLoading] = useState(false)
    const [popup, setPopup] = useState(false);
    const [qrAccessList, setqrAccessList] = useState([]);
    const [popupData, setPopupData] = useState();
    const [fromDate, setFromDate] = useState('')
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [totalItems, setTotalItems] = useState(0);
    const [hasNext, setHasNext] = useState(false);
    const [hasPrevious, setHasPrevious] = useState(false);
    const [limit, setLimit] = useState(10);


    useEffect(() => {
        viewReport()

    }, [dispatch])

    const getHostelList = useCallback(() => {
        // let params = {
        //     page: pageNumber
        // }
        dispatch(Actions.hostelListSelect(""))
    }, [dispatch])

    useEffect(() => {
        getHostelList()
    }, [])

    const onClosePopUp = () => {
        setPopupData('')
        setPopup(false)
    }

    const clearReport = () => {
        setFromDate("")
        setErr("")
        setViewReport("")
        dispatch(Actions.clearReports())
        setFormDetails({ hostel_id: "", ...defaultTimeState })
        setqrAccessList([]);
        setCurrentPage(1);
        setTotalPages(0);
        setTotalItems(0);
        setHasNext(false);
        setHasPrevious(false);


    }
    const viewReport = (page = 1) => {
        if (!formDetails?.hostel_id) {
            setErr({ "hostel_id": "Please select the hostel" })
        } else if (!fromDate) {
            setErr({ "fromDate": "Please select the Date" })
        }
        else {
            const callback = (response) => {
                if (response) {
                    if (response?.response?.length > 0) {
                        setqrAccessList(response?.response)
                        setViewReport(true)

                        // Update pagination states from backend response
                        if (response.pagination) {
                            setTotalPages(response.pagination.total_pages || 0);
                            setTotalItems(response.pagination.total || 0);
                            setHasNext(response.pagination.has_next || false);
                            setHasPrevious(response.pagination.has_previous || false);
                            setCurrentPage(response.pagination.page || 1);
                            setLimit(response.pagination.limit || 10);
                        }
                    } else {
                        toast.error("No data found")
                        // Reset pagination
                        setTotalPages(0);
                        setTotalItems(0);
                        setHasNext(false);
                        setHasPrevious(false);
                    }
                    setLoading(false)
                    setErr("")
                }
                else {
                    toast.error(response?.message)
                    setLoading(false)
                }
            }

            let st_time = moment(fromDate).format('YYYY-MM-DD')
            const params = {
                hostel_id: formDetails?.hostel_id,
                start_time: moment(formDetails?.start_time).format("HH:mm:ss"),
                end_time: moment(formDetails?.end_time).format("HH:mm:ss"),
                date: st_time,
                entry_type: formDetails?.entry_type,
                page: page, // Add page parameter
                limit: limit // Add limit parameter
            }
            setLoading(true)
            setCurrentPage(page); // Update current page
            dispatch(Actions.qrAccessList(params, callback))
        }
    }

    // const handleClick = (url) => {
    //     setPopup(true);
    //     setPopupData(url)

    // }

    const handleClick = (img_urls) => {
        if (!img_urls || img_urls.length === 0) {
            toast.error("Images not available");
            return;
        }

        setPopupData(img_urls);
        setPopup(true);
    };

    const handlePageChange = (pageNumber) => {
        viewReport(pageNumber);
    }
    const handleHostelSelect = (selected) => {
        setViewReport(false)
        setFormDetails({ ...formDetails, 'hostel_id': parseInt(selected) })
        setErr({ ...err, "hostel_id": "" })
        // viewReport(parseInt(selected))
    };

    const getDefaultTimesForDate = (date) => {
        if (!date) return defaultTimeState;
        const isToday = moment(date).isSame(moment(), 'day');
        return {
            start_time: moment(date).set({ hour: 0, minute: 0, second: 0, millisecond: 0 }),
            end_time: isToday ? moment() : moment(date).set({ hour: 23, minute: 59, second: 59, millisecond: 999 }),
        };
    };
    const handleDateSelect = (selected) => {
        setFromDate(selected);
        setFormDetails((prev) => ({ ...prev, ...getDefaultTimesForDate(selected) }));
        setViewReport(false);
        setErr("");
    };

    const handleTimeChange = (value, time) => {
        if (value) {
            if (time === "start_time") {
                setFormDetails({ ...formDetails, [time]: value })
            } else {
                setFormDetails({ ...formDetails, [time]: value })
            }
        }
    }
    const handleEntryTypeSelect = (selected) => {
        setViewReport(false)
        setFormDetails({ ...formDetails, 'entry_type': selected })
        setErr({ ...err, "entry_type": "" })
    };
    const disabledEndMinutes = (selectedHour) => {
        const startMinute = formDetails?.start_time ? moment(formDetails.start_time).minute() : 0;
        const startHour = formDetails?.start_time ? moment(formDetails.start_time).hour() : 0;
        if (selectedHour === startHour) {
            let minutes = [];
            for (let i = 0; i < startMinute; i++) {
                minutes.push(i);
            }
            return minutes;
        }
        return [];
    }

    const disabledEndHours = () => {
        const startHour = formDetails?.start_time ? moment(formDetails.start_time).hour() : 0;
        let hours = [];
        for (let i = 0; i < startHour; i++) {
            hours.push(i);
        }
        return hours;
    };

    const getHostelName = () => hostelList?.find((h) => h?.id == formDetails?.hostel_id)?.name || 'Hostel';
    const getEntryTypeLabel = (v) => (v === 'EN' ? 'Entry' : v === 'EX' ? 'Exit' : 'All');
    const safeFormatDate = (val, formatStr, fallback = '-') => {
        if (val == null || val === '') return fallback;
        const m = moment(val);
        return m.isValid() ? m.format(formatStr) : fallback;
    };
    const getFilterSummaryText = () => {
        const parts = [];
        if (fromDate) parts.push(`Date: ${safeFormatDate(fromDate, 'DD-MM-YYYY')}`);
        if (formDetails?.start_time != null && formDetails?.end_time != null)
            parts.push(`Time: ${safeFormatDate(formDetails.start_time, 'HH:mm')} - ${safeFormatDate(formDetails.end_time, 'HH:mm')}`);
        parts.push(`Entry Type: ${getEntryTypeLabel(formDetails?.entry_type)}`);
        return parts.join(' | ');
    };

    const handleDownload = () => {
        const callback = async (response) => {
            if (response?.status_code !== 0) {
                toast.error("Something went wrong");
                setLoading(false);
                return;
            }
            const rawData = response?.response || [];
            const dataWithoutImages = rawData.map((item, idx) => ({
                'S.No': idx + 1,
                'Name': item?.name ?? '',
                'Member ID': item?.member_id ?? '',
                'Date': moment(item?.access_time).isValid() ? moment(item.access_time).format('YYYY-MM-DD') : '',
                'Time': moment(item?.access_time).isValid() ? moment(item.access_time).format('HH:mm:ss') : '',
                'EN/EX': item.is_entry ? 'EN' : 'EX',
            }));
            const headers = dataWithoutImages.length ? ['S.No', 'Name', 'Member ID', 'Date', 'Time', 'EN/EX'] : [];
            const colCount = Math.max(headers.length, 1);
            const hostelName = getHostelName();
            const filterSummary = getFilterSummaryText();
            const dateStr = safeFormatDate(fromDate, 'DD-MM-YYYY', moment().format('DD-MM-YYYY'));

            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('data', { views: [{ rightToLeft: false }] });
            worksheet.mergeCells(1, 1, 1, colCount);
            worksheet.getCell(1, 1).value = hostelName;
            worksheet.getCell(1, 1).font = { bold: true };
            worksheet.getCell(1, 1).alignment = { horizontal: 'center', vertical: 'middle' };
            worksheet.mergeCells(2, 1, 2, colCount);
            worksheet.getCell(2, 1).value = filterSummary;
            worksheet.getCell(2, 1).font = { bold: true };
            worksheet.getCell(2, 1).alignment = { horizontal: 'center', vertical: 'middle' };
            if (headers.length) {
                const headerRow = worksheet.addRow(headers);
                headerRow.eachCell((cell) => {
                    cell.font = { bold: true };
                    cell.alignment = { horizontal: 'center', vertical: 'middle' };
                });
                dataWithoutImages.forEach((row) => {
                    worksheet.addRow(headers.map((h) => row[h] ?? ''));
                });
            }
            worksheet.columns = headers.map((h) => ({ width: 14 }));
            const buffer = await workbook.xlsx.writeBuffer();
            const fileName = `guest in and out_${dateStr}${EXCEL_EXTENSION}`;
            FileSaver.saveAs(new Blob([buffer], { type: EXCEL_TYPE }), fileName);
            toast.success("Downloaded Successfully");
            setLoading(false);
        };

        const st_time = safeFormatDate(fromDate, 'YYYY-MM-DD', moment().format('YYYY-MM-DD'));
        const params = {
            date: st_time,
            hostel_id: formDetails?.hostel_id,
            start_time: moment(formDetails?.start_time).format("HH:mm:ss"),
            end_time: moment(formDetails?.end_time).format("HH:mm:ss"),
            entry_type: formDetails?.entry_type,
            page: 1,
            limit: 1000,
        };
        setLoading(true);
        dispatch(Actions.qrAccessList(params, callback));
    };
    return (
        <>
            {
                isLoading && <AppLoader />
            }
            <div className="ecommerce-widget">
                <h5 className="card-header">Guest In/Out Report </h5>
                <div className="card border-3 border-top border-top-primary">
                    <div className="row">
                        <div className="col-xl-2 col-lg-3 col-md-6 col-sm-12 col-6 selectDate mx-3">
                            <label htmlFor="exampleInputEmail1" className="form-label">Hostel <span className="text-danger">*</span></label>
                            <select value={formDetails?.hostel_id} onChange={(e) => handleHostelSelect(e?.target?.value)}
                                className="form-select">
                                <option value='' hidden>Select Hostel</option>
                                {Array.isArray(hostelList) && hostelList?.map((o) => {
                                    return <option value={o?.id}>{o?.name}</option>
                                })
                                }
                            </select>
                            <p style={{ 'color': 'red' }}>{err?.hostel_id}</p>
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-6 col-sm-12 col-12 selectDate">
                            <label className="dateLabel">Date <span className="text-danger">*</span></label>
                            <div className="input-group mb">
                                <AppDatePicker
                                    disabled={!formDetails?.hostel_id}
                                    selected={fromDate && moment(fromDate).isValid() ? moment(fromDate).toDate() : null}
                                    placeholder="Date"
                                    maxDate={new Date()}
                                    onChange={(date) => {
                                        handleDateSelect(date)
                                    }}
                                    notValidTime={true}
                                    id='FormDatePicker'
                                />
                            </div>
                            <p style={{ 'color': 'red' }}>{err?.fromDate}</p>
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-6 col-sm-12 col-12 selectDate">
                            <label className="dateLabel">Start Time</label>
                            <div className="input-group w-75">
                                <TimePicker showSecond={false} format={'HH:mm'} disabled={!fromDate} onChange={(v) => handleTimeChange(v, "start_time")} value={formDetails?.start_time ?? defaultTimeState.start_time} disableClock={true} className="form-control  cursor-pointer" />
                            </div>
                            {/* <p style={{ 'color': 'red' }}>{err?.hostel}</p> */}
                        </div>
                        <div className="col-xl-2 col-lg-3 col-md-6 col-sm-12 col-12 selectDate">
                            <label className="dateLabel">End Time</label>
                            <div className="input-group w-75">
                                <TimePicker showSecond={false} format={'HH:mm'} disabled={!fromDate} clearIcon={false} onChange={(v) => handleTimeChange(v, "end_time")} value={formDetails?.end_time ?? defaultTimeState.end_time} disableClock={true} className="form-control dateInput cursor-pointer" disabledHours={disabledEndHours}
                                    disabledMinutes={disabledEndMinutes} />
                            </div>
                            {/* <p style={{ 'color': 'red' }}>{err?.end_time}</p> */}
                        </div>
                        <div className="col-xl col-lg-3 col-md-6 col-sm-12 col-12 selectDate">
                            <label htmlFor="exampleInputEmail1" className="form-label">Entry Type </label>
                            <select value={formDetails?.entry_type} onChange={(e) => handleEntryTypeSelect(e?.target?.value)}
                                className="form-select">
                                <option value='' hidden>Select Type</option>
                                <option value={"EN"}>Entry</option>
                                <option value={"EX"}>Exit</option>
                            </select>
                            <p style={{ 'color': 'red' }}>{err?.entry_type}</p>
                        </div>
                        <div className="col-xl col-lg-3 col-md-6 col-sm-12 col-12 selectDate1">
                            {!viewReports ? <button type="button" className="btn btn-primary" onClick={() => viewReport()}>View</button>
                                : <button type="button"
                                    className="btn btn-primary" onClick={() => handleDownload()}>Download</button>}
                            &nbsp;
                            {(fromDate || hostelList?.length > 0) && <button className="btn btn-primary" onClick={() => clearReport()}>Clear</button>}
                        </div>

                    </div>

                </div>
                {viewReports && (
                    <div className="card mb-3 mt-3 p-3 bg-light rounded">
                        <h6 className="mb-2 fw-bold">Selected filter</h6>
                        <div className="d-flex flex-wrap gap-3 small">
                            <span><strong>Hostel:</strong> {getHostelName()}</span>
                            <span><strong>Date:</strong> {safeFormatDate(fromDate, 'DD-MM-YYYY')}</span>
                            <span><strong>Time:</strong> {formDetails?.start_time != null && formDetails?.end_time != null ? `${safeFormatDate(formDetails.start_time, 'HH:mm')} - ${safeFormatDate(formDetails.end_time, 'HH:mm')}` : '-'}</span>
                            <span><strong>Entry Type:</strong> {getEntryTypeLabel(formDetails?.entry_type)}</span>
                        </div>
                    </div>
                )}
                <div className="card">
                    <div className="card-body p-0">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="table-responsive">
                                    {/* {
                                        (Array.isArray(qrAccessList)) && <h4 className="mt-2 p-2">Presents-{Presentees?.length}</h4>
                                    } */}
                                    {(Array.isArray(qrAccessList) && qrAccessList?.length > 0) &&
                                        <table className="table onboardTable">
                                            <thead className="bg-light">
                                                <tr className="border-0">
                                                    <th className="border-0">S.No</th>
                                                    <th className="border-0">Name</th>
                                                    <th className="border-0">Date</th>
                                                    <th className="border-0">Time</th>
                                                    <th className="border-0">EN/EX</th>
                                                    {/* <th className="border-0">Hostel</th> */}
                                                    {/* <th className="border-0"></th> */}
                                                    {/* <th className="border-0">Suspicious ID</th> */}
                                                    <th className="border-0">Image</th>
                                                    {/* <th className="border-0">Room</th> */}

                                                    {/* <th className="border-0">Remarks</th> */}
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(Array.isArray(qrAccessList) && qrAccessList?.length > 0) && qrAccessList?.map((item, index) => {
                                                    return <tr>
                                                        <td>{(currentPage - 1) * limit + index + 1}</td>
                                                        <td>{item?.name ? `${item.name} (${item.member_id})` : item?.member_id}</td>
                                                        <td>{moment(item?.access_time).format('YYYY-MM-DD')}</td>
                                                        <td>{moment(item?.access_time).format('HH:mm:ss')}</td>
                                                        <td>{item?.is_entry ? 'EN' : 'EX'}</td>
                                                        {/* <td>{item?.message}</td> */}
                                                        {/* <td>{item?.tracker_id}</td> */}
                                                        {item?.img_urls && item.img_urls.length > 0 && <td>
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary"
                                                                onClick={() => handleClick(item?.img_urls)}
                                                            >
                                                                View Images ({item.img_urls.length})
                                                            </button>
                                                        </td>}

                                                    </tr>
                                                })}
                                                <tr>
                                                    <td colSpan="9">
                                                        <PaginationComponent
                                                            onChangeHandle={handlePageChange}
                                                            pageCount={totalItems}
                                                            pageNumber={currentPage}
                                                            setpage={setCurrentPage}
                                                        />
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>}
                                    {qrAccessList?.length === 0 && <div className="d-flex justify-content-center mt-5 mb-5">
                                        <div className="NodataFound mb-3">
                                            <h3>No Data Found</h3>
                                        </div>
                                        <div className="NodataImage">
                                            <img src={nodatafound} alt="No Data Found" className="NoData" />
                                        </div>
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {
                popup && <ViewQrImagePopup onClose={() => onClosePopUp(false)} data={popupData} />

            }


        </>
    )
}